import { initializeKeycloak, keycloak } from "@/entities/keycloak";

export async function initKeycloak() {
  return initializeKeycloak().then(async (_status) => {
    if (!keycloak.authenticated) {
      return keycloak.login();
    }
    const resp = await fetch("/backend/auth", {
      headers: {
        Authorization: `Bearer ${keycloak.token}`,
      },
    });
    if (resp.status === 401) {
      // logout right away if user tries login to different client
      return keycloak.logout();
    }
    if (resp.status !== 200) {
      // this should never happen as we always should get 200 code from backend when user is in correct client
      console.error(resp.status, await resp.text());
      // TODO better message here?
      document.body.innerHTML = "Something went wrong, please contact support";
      return;
    }
    // successfully continue as response is successful 2XX
    const respBody = await resp.text();
    // redirect to correct client for superuser
    if (respBody) {
      if (import.meta.env.DEV) {
        // Sharing integration's Keycloak and database means the backend resolves
        // our group to that client's deployed URL, which would bounce us off
        // localhost immediately.
        console.warn(`[dev] skipping backend redirect to ${respBody}`);
        return;
      }
      window.location.href = respBody;
      return;
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
